var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { objectOf, oneOf, number, string } from 'prop-types';
import { BreakpointsContext } from './BreakpointsContext';
import { useMatchMediaBreakpoints } from './useMatchMediaBreakpoints';
import { validateBreakpoints } from './helpers/validateBreakpoints';
/**
 * Provides the breakpoints for the Consumer components
 *
 * Detects current breakpoint using media queries
 * - [matchMedia]( https://developer.mozilla.org/en-US/docs/Web/API/Window/matchMedia)
 * - [MediaQueryList](https://developer.mozilla.org/en-US/docs/Web/API/MediaQueryList)
 *
 * Uses CSS media queries [level 3](https://www.w3.org/TR/css3-mediaqueries/)
 * - min-width
 * - max-width
 */
export function MatchMediaBreakpoints(props) {
    validateBreakpoints(props.breakpoints);
    var children = props.children, breakpoints = props.breakpoints, _a = props.breakpointUnit, breakpointUnit = _a === void 0 ? 'px' : _a, defaultBreakpoint = props.defaultBreakpoint;
    var currentBreakpoint = useMatchMediaBreakpoints({
        breakpoints: breakpoints,
        breakpointUnit: breakpointUnit,
        defaultBreakpoint: defaultBreakpoint,
    });
    var contextProps = useMemo(function () {
        return {
            breakpoints: breakpoints,
            currentBreakpoint: currentBreakpoint,
        };
    }, [breakpoints, currentBreakpoint]);
    return (_jsx(BreakpointsContext.Provider, __assign({ value: contextProps }, { children: children }), void 0));
}
MatchMediaBreakpoints.propTypes = {
    breakpoints: objectOf(number).isRequired,
    breakpointUnit: oneOf(['px', 'em']),
    defaultBreakpoint: string,
};
export default MatchMediaBreakpoints;
//# sourceMappingURL=MatchMediaBreakpoints.js.map